<template>
  <div class="lesson-task-marking">
    <div class="lesson-task-marking-header">
      <el-row>
        <el-col :span="6">
          <h6 class="student-name" v-text="expInfo.name || '-'"></h6>
          <div class="mark-list">
            {{ expInfo.expName }}实验报告
          </div>
        </el-col>
        <el-col :span="18">
          <div class="text-r">
            <p class="lesson-task-marking-submit" v-if="expInfo.report && expInfo.canRevise">
              <el-button type="info" size="mini" :disabled="!(!submitFlag && canSave)" @click="reviseSave">
                保存
              </el-button>
              <el-button type="success" size="mini" :disabled="!(!submitFlag && canSave)" @click="reviseSubmit">
                提交
              </el-button>
            </p>
            <div class="lesson-task-marking-tools">
              <div class="lesson-task-marking-tool" v-if="expInfo.canEdit">
                <el-button
                    size="small" type="text" v-for="(item, key) in oMarks" :key="key"
                    :class="`tool tool-${key} ${key === curTool ? 'active' : ''}`" :title="item.name"
                    @click="changeCurTool(key)"
                ></el-button>
              </div>
              <div class="lesson-task-marking-tool">
                <el-button
                    class="btn-revise-save" plain size="mini" v-if="expInfo.canRevise && !expInfo.report"
                    :disabled="!canSaveRevise" @click="reviseSave"
                >
                  保存
                </el-button>
                <div class="paf-page-cur">
                  <el-input
                      class="page-cur" size="small" type="number" min="1" :max="totalPage" v-model="pageNum"
                      @change="handleChange"
                  ></el-input>
                  &nbsp;&nbsp;/&nbsp;&nbsp;{{ totalPage }}
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="pdf-box">
      <div class="pdf-body" id="pdfBody" ref="pdfBody">
        <div class="pdf-wrapper">
          <div id="container" ref="pdfContainer" @click="padClick">
            <div class="page img-content" id="page-1" style="width: 950px">
              <div class="textLayer" ref="textLayer">
                <div class="title">{{ expInfo.expName }}实验报告</div>
                <table class="report-table" border="0" cellspacing="1" cellpadding="0">
                  <tbody>
                  <tr class="rt-tr">
                    <td class="td-t">实验项目名称</td>
                    <td class="td-c" colspan="3">{{ expInfo.expName }}</td>
                    <td class="td-t">指导教师</td>
                    <td class="td-c">{{ expInfo.teacher }}</td>
                    <td class="td-t">实验成绩</td>
                    <td class="td-c" v-if="expInfo.reports">{{
                        reportTotalScore ? reportTotalScore : expInfo.score
                      }}
                    </td>
                    <td class="td-c" v-if="expInfo.report">{{ newPreData.config.goal }}</td>
                  </tr>
                  <tr class="rt-tr">
                    <td class="td-t">学院</td>
                    <td class="td-c">-</td>
                    <td class="td-t">专业班级</td>
                    <td class="td-c">-</td>
                    <td class="td-t">姓名</td>
                    <td class="td-c">{{ expInfo.name }}</td>
                    <td class="td-t">提交日期</td>
                    <td class="td-c">{{ expInfo.time ? (expInfo.time).split(' ')[0] : '-' }}</td>
                  </tr>
                  <tr class="rt-tr">
                    <td colspan="8" class="content-td">
                      <div class="reports" v-if="expInfo.reports">
                        <div v-for="(report, rIdx) in reportList" :key="report.id" class="report">
                          <div class="report-title">
                            <img src="~@/assets/imgs/ic_file.png" alt="">
                            {{ report.name }}
                            <div class="report-answers">
                              <el-popover
                                  placement="bottom"
                                  width="400"
                                  trigger="click"
                                  :content="report.answers">
                                <el-button slot="reference" size="mini" type="info" v-if="expInfo.canEdit">参考答案
                                </el-button>
                              </el-popover>
                            </div>
                            <div class="report-score">
                              得分:&nbsp;
                              <el-input
                                  size="small" type="number" placeholder="0" min="0" :max="report.totalScore"
                                  v-if="expInfo.canEdit" v-model.number="report.score"
                                  @change="reportScoreChange($event, report)"
                              ></el-input>
                              <span v-else>{{ report.score || 0 }}</span>
                              &nbsp;/&nbsp;{{ report.totalScore || '-' }}
                            </div>
                          </div>
                          <div class="report-content-box">
                            <div class="report-content" v-html="report.content"></div>
                            <div
                                v-if="expInfo.canRevise"
                                class="report-revise"
                                :class="{
                                  focus: report.focus,
                                  'is-revise': report.isRevise
                                }">
                              <editor
                                  :content="report.content" @onfocus="onfocus(rIdx)"
                                  @onchange="onchange($event, rIdx)" @onblur="onblur(rIdx)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="reports" v-else-if="expInfo.report">
                        <fm-generate-form
                            ref="generateForm"
                            :class="[expInfo.canRevise?'reports-generate-form':'']"
                            :data="newPreData"
                            :isTeacher="expInfo.canEdit"
                            :disable="!expInfo.canRevise || !(!submitFlag && canSave)"
                            :custom-config="customConfig"
                        ></fm-generate-form>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="annotations-list-uoc" :style="{ right: `calc(50% - (${width}px / 2))` }">
              <div class="annotations-panel" @click="showAnnexList = !showAnnexList">
                <div class="panelSpan" title="批注列表">
                  <span class="label-counter" v-text="curMarks.length"></span>
                  <span class="panelSpanSpan"><br>批<br>注<br>列<br>表</span>
                </div>
              </div>
              <div :class="{ slimScrollDiv: true, open: showAnnexList }">
                <ul class="container-anotacions">
                  <li class="annotator-marginviewer-element" v-for="mark in curMarks" :key="mark.id"
                      @mouseenter="handleMouseenter($event, mark.id)" @mouseleave="handleMouseleave($event, mark.id)">
                    <div class="annotator-marginviewer-text" @click="goMarkPos(mark)">
                      <img class="annotatoricon" :src="require('@/assets/imgs/'+mark.type+'0.png')">
                    </div>
                    <div class="annotator-marginviewer-footer">
                      <div class="footerInfo">
                        <el-row>
                          <el-col :span="12">
                            <span class="label-compartit">{{ oMarks[mark.type].name }}</span>
                          </el-col>
                          <el-col class="text-r" :span="12">
                            <div v-text="mark.createTime"></div>
                          </el-col>
                        </el-row>
                      </div>
                      <div class="annotator-viewer-delete footerDel" align="center" v-if="expInfo.canEdit"
                           @click="delDomMarkConfirm(mark.id)">
                        <span class="label">删除</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="expInfo.canEdit && $route.params.uid" class="page-btn">
      <el-row class="page-btn-el">
        <!-- <el-col :span="14" :offset="10"> -->
        <el-col :span="3" :offset="9">
          <el-button size="mini" type="danger" v-if="[1,2].indexOf(expInfo.status) > -1" @click="repulse">打回报告
          </el-button>
        </el-col>
        <el-col :span="3">
          <el-button size="mini" type="warning" @click="getCurrentPdf()">导出报告</el-button>
        </el-col>
        <el-col :span="3">
          <el-button size="mini" type="primary" @click="handSave">保存批阅</el-button>
        </el-col>
        <el-col :span="3">
          <el-button size="mini" type="primary" :disabled="!expInfo.preUid" @click="changeStudent(expInfo.preUid)">
            上个学生
          </el-button>
        </el-col>
        <el-col :span="3">
          <el-button size="mini" type="primary" :disabled="!expInfo.nextUid" @click="changeStudent(expInfo.nextUid)">
            下个学生
          </el-button>
        </el-col>
      </el-row>
    </div>

    <div
        class="annotation-text" v-if="curTool === 'annotation' && curAnnexInfo"
        :style="{ left: curAnnexInfo.l, top: curAnnexInfo.t }"
    >
      <div>
          <el-alert size="mini" title="请使用回车键对文字换行" type="success" :closable="false"> </el-alert>
      </div>
      <el-input
          ref="linefeedInput"
          type="textarea" placeholder="请输入内容" :autosize="{ minRows: 3, maxRows: 6}"
          v-model="curAnnexInfo.text"
      ></el-input>
      <div class="annotator-controls">
        <el-button size="mini" @click="curAnnexInfo = null">取消</el-button>
        <el-button type="primary" size="mini" @click="drTextSvg">确定</el-button>
      </div>
    </div>

    <el-dialog title="统一给分" width="30%" :visible.sync="uniformDistribution">
      <el-form ref="form" label-width="80px" :model="form" :rules="rules">
        <el-form-item label="小组分数" prop="score">
          <el-input-number size="small" label="分数" :min="0" v-model="form.score"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="uniformDistribution = false">取 消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { curentTime, hasClass } from "@/utils/util.js";
import { dragMark, insertMark, insertSvg, insertSvgText, reviewMark } from "@/utils/drag";
import { getMaskExpInfo, reviewReports, setReportScore, submitReport } from "@/api/lab/experiment";
import { addMark, delMark, getMarkList, getRaceMarkList, updateMark } from "@/api/exp/mark";
import { editReportContent, getGraded, update } from "@/api/lab/labexperiment2user";
import editor from "@/components/common/editor";
import { getFamtterTimer } from "@/utils/time";
import { baseUrl, staticUrl } from "@/config/env";

export default {
  data() {
    return {
      baseUrl: '',
      submitFlag: false,  //提交状态
      htmlTitle: '',
      htmlType: '',
      htmlId: null,
      arr: [],
      score: null, // 成绩
      initFlag: true,
      pdfDoc: null,
      totalPage: 0,
      pageNum: 1,
      container: null,
      scale: 2, // PDF区域的缩放值
      minScale: 0.5, // 最小缩放值
      width: 950,
      height: 0,
      scrollTop: 0,
      curMarks: [], //当前附件的批注列表
      showAnnexList: false, // 展开批注列表
      curAnnexInfo: null,
      curTool: null, // 当前的批阅类型
      oMarks: {
        arrow: { name: "箭头", icon: "el-icon-check" },
        correct: { name: "正确", icon: "el-icon-check" },
        error: { name: "错误", icon: "el-icon-close" },
        righterror: { name: "半对", icon: "el-icon-check" },
        doubt: { name: "疑问", icon: "el-icon-question" },
        polyline: { name: "涂鸦", icon: "el-icon-question" },
        rect: { name: "矩形", icon: "el-icon-question" },
        ellipse: { name: "椭圆", icon: "el-icon-question" },
        annotation: { name: "批注", icon: "el-icon-question" },
      },
      uniformDistribution: false,
      form: {},
      rules: {
        score: [{ required: true, message: "请输入分值", trigger: "blur" }],
      },
      raceExpInfo: {},
      raceGroupInfo: {},
      raceExpGroupReport: [],
      lessonExpInfo: {},
      reportList: [], // 报告列表
      newPreData: {},
    };
  },
  created() {
    this.baseUrl = baseUrl;
    this.init();
  },
  components: {
    editor,
  },
  watch: {
    curTool(n) {
      if (n == null) {
        this.$refs.pdfContainer.style.cursor = `auto`;
        const svgs = document.getElementsByClassName("svgContainer");
        setTimeout(() => {
          for (let i = 0; i < svgs.length; i++) svgs[i].style.zIndex = null;
        }, 50);
      } else {
        let cur = "tuyamove";
        if (["correct", "error", "righterror", "doubt"].contains(n)) {
          cur = n;
        } else {
          const svgs = document.getElementsByClassName("svgContainer");
          setTimeout(() => {
            for (let i = 0; i < svgs.length; i++) svgs[i].style.zIndex = 999;
          }, 50);
        }
        this.$refs.pdfContainer.style.cursor = `url(${require(`@/assets/imgs/${cur}.png`)}),auto`;
      }
    },
    'expInfo.reports'(list = []) {
      this.reportList = JSON.parse(JSON.stringify(list))
    },
    'newPreData': {
      deep: true,
      handler: function (newVal) {
        let sum = 0
        newVal.list.map(item => {
          sum += item.goal
        })
        this.$set(this.newPreData.config, 'goal', sum)
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'token']),
    expType() {
      const {uid} = this.$route.params
      let type = ''
      if (uid) {
        type = 'lesson'
      }
      return type
    },
    customConfig() {
      let obj = {
        uploadImgHooks: {
          customInsert: this.customInsert,
        },
        uploadImgHeaders: {
          token: this.token,
        },
        uploadImgServer: `${baseUrl}/api/file/uploadFile`,
      };
      return obj;
    },
    expInfo: function () {
      let info = {
        name: '',
        expName: '',
        status: 2,
        statusText: '-',
        score: null,
        canEdit: false, // 是否能打分
        canRevise: false, // 是否能修改答案
        time: '',
        nextUid: undefined,
        preUid: undefined,
        teacher: "",
      }
      let {expType} = this
      if (expType === 'lesson') {
        const {lessonExpInfo} = this
        const {status, username, cutoffTime} = lessonExpInfo
        info = {
          ...info,
          ...lessonExpInfo,
          canRevise: this.userInfo.username === username && status !== 2 && new Date(Date.parse(cutoffTime)) > new Date()
        }
      }
      return info
    },
    reportTotalScore: function () {
      let score = 0
      this.reportList.map(key => {
        score += Number(key.score)
      })
      return score
    },
    reportData: function () {
      let arr = []
      let obj = {}
      this.reportList.map(key => {
        obj = {
          uid: key.uid,
          score: key.score
        }
        arr.push(obj)
      })
      return arr
    },
    reviseReports: function () {
      return this.reportList.filter((item, index) => {
        // 原报告内容
        const {content} = this.expInfo.reports[index]
        return item.content !== content
      })
    },
    canSave() {
      const {cutoffTime, status} = this.lessonExpInfo
      let now = new Date().getTime()
      let end = new Date(cutoffTime).getTime()
      let flag = (status === 0 || status === 3)
      return (end > now) && flag
    },
    canSaveRevise: function () {
      const {cutoffTime} = this.lessonExpInfo
      let now = new Date().getTime()
      let end = new Date(cutoffTime).getTime()
      return end > now
    },
  },
  methods: {
    ...mapActions(["setRefresh"]),
    init() {
      this.initExp()
    },
    customInsert(insertImg, result){
        let data = [`${staticUrl}/${result.data.originalPath}`];
        JSON.stringify(data);
        insertImg(data);
    },
    handSave() { // 保存为pdf操作
      if (this.expInfo.report) {
        let newReport = JSON.stringify(this.newPreData)
        let params = {
          id: this.expInfo.id,
          status: this.expInfo.status,
          score: this.newPreData.config.goal,
          report: newReport
        }
        if (this.expInfo.status === 1)
          params.status = 2
        editReportContent(params)
            .then(() => {
              this.htmlType = 'all'
              this.htmlId = this.expInfo.id
              this.getPdf()
              // this.$message.success('操作成功')
            })
      } else if (this.expInfo.reports) {
        const {uid} = this.$route.params
        let data = this.reportData
        reviewReports(uid, data)
            .then(() => {
              this.$message.success('操作成功!')
              this.htmlType = 'all'
              this.htmlId = this.expInfo.id
              this.getPdf()
            })
            .catch(() => {
            })
      }
    },
    repulse() {  //打回作业
      const {id} = this.expInfo
      update({
        id,
        status: 3
      })
          .then(() => {
            this.initLessonExp()
            this.$message.success('已打回该学生作业')
          })
          .catch(() => {
          })
    },
    initExp() {
      let {expType} = this
      if (expType === 'lesson') {
        this.initLessonExp()
      }
    },
    // 初始化课堂实验数据
    initLessonExp(
        {uid} = this.$route.params
    ) {
      getMaskExpInfo(uid)
          .then((res = {expName: "", name: ""}) => {
            this.htmlTitle = `${res.expName}-${res.name}`
            this.totalPage = 1
            this.lessonExpInfo = res
            if (this.lessonExpInfo.report) {
              let obj = JSON.parse(this.lessonExpInfo.report)
              if (typeof (obj) == 'string') {
                obj = JSON.parse(obj)
              }
              obj.list
                  .map((item) => {
                    if (!item.model) {
                      item.model = item.key;
                    }
                    if (item.type === 'checkbox') {
                      if (typeof (item.defaultValue) === 'string') {
                        item.defaultValue = item.defaultValue.split(',')
                      }
                    }
                    item.rules = []
                  })
              this.newPreData = obj
            }
            this.initCurPage()
          })
    },
    UD() {
      this.form = {}
      this.uniformDistribution = true
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.scoreChange(this.form.score)
          this.uniformDistribution = false
        } else {
          return false
        }
      })
    },
    /**
     * 保存svg文本信息
     */
    drTextSvg() {
      insertSvgText(this.curAnnexInfo, (entity, shape, rect, delBtn) => {
        this.addMark(entity).then(res => {
          shape.setAttribute('id', `mark-${res}`)
          rect.setAttribute("id", `selector-${res}`)
          delBtn.setAttribute('id', `del-${res}`)
          shape = null;
          this.curMarks.push({
            ...entity,
            id: res,
            createTime: curentTime(),
            type: this.curTool
          })
          this.curAnnexInfo = null;
          this.curTool = null
        })
      })
    },
    /**
     * 页面改变事件
     */
    handleChange(value) {
      let top = (value - 1) * this.height;
      this.scrollTop = document.body.scrollTop = document.documentElement.scrollTop = top
    },
    /**
     * 页面滚动事件
     */
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    },
    initCurPage() {
      this.$nextTick(() => {
        this.initPage()
        this.initMarking()
      })
    },
    getCurrentPdf() {
      this.htmlType = 'current'
      this.getPdf()
    },
    setReportScore(score) {
      setReportScore(this.$route.params.uid, score).then(() => {
        this.expInfo.score = score
        this.$message.success('成绩已修改!')
        this.setRefresh(true)
        this.initCurPage()
        // this.$router.go(0)   //改一次分数就刷一次
      });
    },
    initPage() {
      this.height = document.getElementById('page-1').scrollHeight
      const svgDiv = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svgDiv.setAttribute('width', '950px');
      svgDiv.setAttribute('height', `${this.height}px`);
      svgDiv.setAttribute('id', `svgContainer1`)
      svgDiv.setAttribute('class', `svgContainer`)
      svgDiv.setAttribute('style', `top: 0`)
      this.$refs.textLayer.appendChild(svgDiv);
    },
    // 在 作业分数 值改变时触发
    scoreChange(score) {
      // this.$print(this.$refs.pdfBody)
      this.setReportScore(score)
    },
    /**
     * 修改批注类型
     */
    changeCurTool(tool) {
      this.curTool = this.curTool === tool ? null : tool;
    },
    // 初始化获取批注列表
    async initMarking() {
      const { expUid, groupUid, uid } = this.$route.params;
      let curMarks = []
      if (uid) {
        await getMarkList(uid)
            .then(res => {
              curMarks = res
            })
      } else {
        await getRaceMarkList(expUid, groupUid).then((res) => {
          curMarks = res;
        });
      }
      // 回显批注
      this.$nextTick(() => {
        setTimeout(() => {
          reviewMark(curMarks, this.expInfo.canEdit)
        }, 500)
      })
      this.curMarks = curMarks
    },
    getId(doMid) {
      return doMid.split('-')[1];
    },
    /**
     * 点击添加批注
     */
    padClick(ev) {
      this.curAnnexInfo = null
      if (this.curTool === 'annotation') {
        let scrollTop = (document.getElementById("app")).scrollTop || 0
        // 计算图标的位置
        let top = ev.clientY - 110;
        let left = (ev.clientX - (document.body.offsetWidth - this.width) / 2);
        // 绘制svg - text
        this.curAnnexInfo = {
          type: 'annotation',
          pageLeft: left,
          pageTop: top + scrollTop,
          l: `calc(50% - ${(this.width / 2) - left + 8}px)`,
          t: `${top + 110 - 116 - 8}px`,
          text: ''
        }
      } else {
        this.insertMarkToDom(ev);
      }
    },
    // 添加批注到页面中
    insertMarkToDom(ev) {
      insertMark(this.curTool, null, ev, 0, this.width, (entity, mark, delBtn) => {
        if (!entity)
          return;
        this.addMark(entity).then(res => {
          mark.setAttribute('id', 'mark-' + res)
          delBtn.setAttribute('id', 'del-' + res)
          this.curMarks.push({
            ...entity,
            id: res,
            createTime: curentTime(),
            type: this.curTool
          })
        })
      })
    },
    // 添加svg批注到页面中
    insertSvgToDom(svgDom) {
      insertSvg(svgDom, this.curTool, (entity, shape, rect, delBtn) => {
        this.addMark(entity).then(res => {
          shape.setAttribute('id', `mark-${res}`)
          rect.setAttribute("id", `selector-${res}`)
          delBtn.setAttribute('id', `del-${res}`)
          shape = null;
          this.curMarks.push({
            ...entity,
            id: res,
            createTime: curentTime(),
            type: this.curTool
          })
        }).catch(err => {
          console.warn(err.message || '未知错误')
        })
      })
    },
    /**
     * 添加批注
     */
    addMark(mark) {
      const {uid} = this.expInfo;
      const { expUid, groupUid } = this.$route.params;
      let params = {
        type: this.curTool,
        ...mark
      }
      if (uid) {
        params = {
          ...params,
          expUid: uid
        }
      } else {
        params = {
          ...params,
          raceExp: expUid,
          raceGroup: groupUid,
        };
      }
      return addMark(params)
    },
    delDomMarkConfirm(id) {
      this.$confirm('此操作将永久删除该标注, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delDomMark(id);
      }).catch(() => {
      })
    },
    /**
     * 删除批注
     */
    delDomMark(markId) {
      const markDom = document.getElementById(`mark-${markId}`);
      const selDom = document.getElementById(`selector-${markId}`);
      const delBtn = document.getElementById(`del-${markId}`);
      if (markDom)
        markDom.parentNode.removeChild(markDom);
      if (selDom)
        selDom.parentNode.removeChild(selDom);
      if (delBtn)
        delBtn.parentNode.removeChild(delBtn);

      // 删除标记 - 数据
      const mark = this.curMarks.filter(row => row.id == markId );
      this.curMarks.remove(mark[0])
      // 删除标记 - 数据库
      delMark([markId])
      console.log(1123, this.curMarks, mark)
    },
    handleMouseenter(ev, id) {
      let mark = document.getElementById(`mark-${id}`)
      if (mark) {
        mark.classList.add('active')
      }
    },
    handleMouseleave(ev, id) {
      let mark = document.getElementById(`mark-${id}`)
      if (mark) {
        mark.classList.remove('active')
      }
    },
    goMarkPos(row) {
      let mark = document.getElementById(`mark-${row.id}`)
      if (mark) {
        window.scrollTo(0, Number(mark.offsetTop || mark.getAttribute('y2')) + (row.page - 1) * this.height)
      }
    },
    // 切换学生作业
    changeStudent(uid) {
      this.$router.push({
        name: 'lessonExpMarking',
        params: {uid}
      })
      location.reload(true) // 重新加载页面
    },
    reportScoreChange(score, report) {
      const {totalScore,} = report
      // let {expType} = this
      if (score >= 0 && score <= totalScore) {
        // TODO 打分
        // do something
      } else {
        this.$message.warning('请正确打分!')
      }
    },
    onfocus(index) {
      this.$set(this.reportList[index], 'focus', true)
    },
    onchange(newContent, index) {
      const {content = ''} = this.expInfo.reports[index]
      this.$set(this.reportList[index], 'content', newContent)
      this.$set(this.reportList[index], 'isRevise', newContent !== content)
    },
    onblur(index) {
      this.$set(this.reportList[index], 'focus', false)
    },
    reviseSubmit() {   //提交操作
      if (this.expInfo.report) {
        this.$refs.generateForm.getData().then(data => {
          let obj = this.$refs.generateForm.data
          let newObj = JSON.parse(JSON.stringify(obj))
          obj.list.map(item => {
            let model = item.model
            item.defaultValue = data[model]
          })
          newObj.list.map(item => {
            let model = item.model
            item.goal = 0
            if (item.type === "checkbox") {
              data[model].sort()
              data[model] = data[model].filter(s => {
                return s && s.trim()
              })
              item.defaultValue = data[model].join(',')
            } else {
              item.defaultValue = data[model]
            }
          })
          let id = this.expInfo.id
          let report = JSON.stringify(newObj)
          let submitTime = getFamtterTimer(+new Date())
          let params = {
            id,
            report,
            submitTime
          }
          if (this.expInfo.status === 0 || this.expInfo.status === 3) {
            params.status = 1
          }
          this.$confirm("提交报告后将无法修改，是否确认提交报告？", "确认信息", {
            distinguishCancelAndClose: true,
            confirmButtonText: "提交",
            cancelButtonText: "放弃提交",
          })
              .then(() => {
                editReportContent(params).then(() => {
                  this.getGraded(params.id);
                });
              })
              .catch(() => {});
          })
          .catch(() => {});
      } else {
        let uid = this.$route.params.uid;
        let newArr = [];
        this.reportList.map((item) => {
          newArr.push({ uid: item.uid, answer: item.content });
        });
        submitReport(uid, newArr).then(() => {
          this.$message.success("报告提交成功！");
        });
      }
    },
    getGraded(id) {
      //自动评分
      getGraded(id)
        .then(() => {
          this.submitFlag = true;
          this.$message.success("操作成功!");
        })
        .catch(() => {});
    },
    reviseSave() {
      //保存操作
      if (this.expInfo.report) {
        this.$refs.generateForm.getData().then(data => {
          let obj = this.$refs.generateForm.data
          let newObj = JSON.parse(JSON.stringify(obj))
          obj.list.map(item => {
            let model = item.model
            item.defaultValue = data[model]
          })
          newObj.list.map(item => {
            let model = item.model
            if (item.type === "checkbox") {
              data[model].sort()
              data[model] = data[model].filter(s => {
                return s && s.trim()
              })
              item.defaultValue = data[model].join(',')
            } else {
              item.defaultValue = data[model]
            }
          })
          let id = this.expInfo.id
          let report = JSON.stringify(newObj)
          let submitTime = getFamtterTimer(+new Date())
          let params = {
            id,
            report,
            submitTime
          }
          editReportContent(params).then(() => {
            this.$message.success('操作成功!')
          })
        }).catch(() => {
        })
      } else {
        let uid = this.$route.params.uid
        let newArr = []
        this.reportList.map(item => {
          newArr.push({uid: item.uid, answer: item.content})
        })
        submitReport(uid, newArr).then(() => {
          this.$message.success('报告提交成功！');
        })
      }
    },
    // 监听鼠标右键事件
    handleMouseDownUp(e) {
      if (e.button == 2) {
        if (this.curTool) this.curTool = null;
      }
    },
  },
  destroyed() {
    window.removeEventListener("mousedown", this.handleMouseDownUp);
    window.removeEventListener("contextmenu", (e) => {
      e.preventDefault();
    });
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("mousedown", this.handleMouseDownUp);
      window.addEventListener("contextmenu", (e) => {
        e.preventDefault();
      });

      // 添加滚动事件
      // window.addEventListener('scroll', this.handleScroll)
      let pdfDom = document.getElementById('container')
      // 添加移动事件 当用户按下鼠标按钮执行Javascript代码
      pdfDom.onmousedown = e => {
        if (e.button == 2) return;
        let dragging = false;
        e = e || window.event;
        const target = e.target || e.srcElement;
        const className = typeof target.className == 'string' ? target.className : target.className.baseVal
        if (className.indexOf('marking') > -1) {
          dragMark(target, dragging, this.width, this.height, e, (x, y) => {
            updateMark({
              id: this.getId(target.getAttribute('id')),
              pageTop: `${y}px`,
              pageLeft: `${x}px`
            })
          })
        } else if (className.indexOf('svgContainer') > -1 && this.curTool !== "annotation") {
          // svg画图
          this.insertSvgToDom(target);
        } else if (target.tagName == "rect") {
          dragMark(target, dragging, this.width, this.height, e, (x, y) => {
            let text;
            if (target.previousElementSibling.localName == "polyline" || (target.previousElementSibling.localName == "polygon" && x && y)) {
              let str = target.previousElementSibling.attributes.points.value;
              let arr = str.split(" ");
              let newArr = [];
              arr.map((item) => {
                let data = item.split(",");
                data[0] = Number(data[0]) + x;
                data[1] = Number(data[1]) + y;
                newArr.push(data.toString());
              });
              text = {
                points: newArr.join(" "),
                x: target.attributes.x.nodeValue,
                y: target.attributes.y.nodeValue,
                x1: target.attributes.x.nodeValue,
                y1: target.attributes.y.nodeValue,
                x2: Number(target.attributes.x.nodeValue) + Number(target.attributes.width.nodeValue),
                y2: Number(target.attributes.y.nodeValue) + Number(target.attributes.height.nodeValue),
                width: target.attributes.width.nodeValue,
                height: target.attributes.height.nodeValue,
              };
            } else if (target.previousElementSibling.localName == "text" && x && y) {
              let arr = this.curMarks.filter((item) => {
                return item.id == target.id.replace("selector-", "");
              });

              let obj = JSON.parse(arr[0].text);

              var str = "";
              obj.arr.map((item, index) => {
                let k = `<tspan x="${x}" y="${y + 20 * (index + 1)}">${item}</tspan >`;
                str += k;
              });

              text = {
                x: x,
                y: y,
                width: target.attributes.width.nodeValue,
                height: target.attributes.height.nodeValue,
                font: str,
                arr: obj.arr,
              };
            } else {
              let arr = this.curMarks.filter((item) => {
                return item.id == target.id.replace("selector-", "");
              });
              let obj = JSON.parse(arr[0].text);
              if (target.previousElementSibling.localName == "rect" && x && y) {
                text = {
                  ...obj,
                  x: x,
                  y: y,
                  x1: x,
                  y1: y,
                };
              } else if (target.previousElementSibling.localName == "ellipse" && x && y) {
                text = {
                  ...obj,
                  x: x,
                  y: y,
                  x1: x,
                  y1: y,
                  x2: x + obj.width,
                  y2: y + obj.height,
                  cx: obj.rx + x,
                  cy: obj.ry + y,
                };
                const ellipse = target.previousElementSibling;
                ellipse.setAttribute("cx", text.cx);
                ellipse.setAttribute("cy", text.cy);
              }
            }
            if (x && y) {
              updateMark({ id: this.getId(target.getAttribute("id")), text: JSON.stringify(text) }).then(() => {
                if (target.previousElementSibling.localName == "polyline" || target.previousElementSibling.localName == "polygon") {
                  const polyline = target.previousElementSibling;
                  let points = target.previousElementSibling.attributes.points.value;
                  let arr = points.split(" ");
                  let newArr = [];
                  arr.map((item) => {
                    let data = item.split(",");
                    data[0] = Number(data[0]) + x;
                    data[1] = Number(data[1]) + y;
                    newArr.push(data.toString());
                  });
                  polyline.setAttribute("points", newArr.join(" "));
                } else if (target.previousElementSibling.localName == "ellipse") {
                  const ellipse = target.previousElementSibling;
                  ellipse.setAttribute("cx", text.cx);
                  ellipse.setAttribute("cy", text.cy);
                } else if (target.previousElementSibling.localName == "text" || target.previousElementSibling.localName == "rect") {
                  const node = target.previousElementSibling;
                  var divLength = node.childNodes.length;
                  node.setAttribute("x", x);
                  node.setAttribute("y", y);
                  for (var i = 0; i < divLength; i++) {
                    node.childNodes[i].setAttribute("x", x);
                    node.childNodes[i].setAttribute("y", y + (i + 1) * 20);
                  }
                }
              });
            }
          });
        }
      };
      // 鼠标移入事件
      pdfDom.onmouseover = (e) => {
        e = e || window.event;
        const target = e.target || e.srcElement;
        let domId;
        if (target.nodeName == "tspan") {
          domId = target.parentNode.getAttribute("id");
        } else {
          domId = target.getAttribute("id");
        }
        if (!domId) return;
        if (domId.indexOf('mark-') > -1) {
          const id = domId.split('-')[1];
          const selDom = document.getElementById(`selector-${id}`);
          const delBtn = document.getElementById(`del-${id}`);
          setTimeout(() => {
            if (selDom)
              selDom.style.display = 'block';
            if (delBtn)
              delBtn.style.display = 'block';
          }, 100)
        }
      };
      pdfDom.onmouseout = (e) => {
        e = e || window.event;
        const target = e.target || e.srcElement;
        const domId = target.getAttribute("id");
        if (!domId) return;
        if (domId.indexOf("selector-") > -1 || domId.indexOf("mark-") > -1) {
          const id = this.getId(domId);
          const selDom = document.getElementById(`selector-${id}`);
          const delBtn = document.getElementById(`del-${id}`);
          setTimeout(() => {
            if (selDom)
              selDom.style.display = 'none';
            if (delBtn)
              delBtn.style.display = 'none';
          }, 2000)
        }
      }
      /**
       * 添加删除事件
       */
      pdfDom.addEventListener("click", (e) => {
        const target = e.target || e.srcElement;
        if (target && hasClass(target, "mark-btn")) {
          e.preventDefault();
          // 删除指定批注
          let markId = this.getId(e.target.getAttribute('id'));
          if (markId) {// 删除对应的元素
            this.delDomMark(markId)
          }
        }
      })
    })
  }
}
</script>

<style lang="less">
@import url("~@/assets/css/lesson/exp/marking/main.less");
.lesson-task-marking {
  .lesson-task-marking-submit {
    margin-bottom: 10px;
  }
  .page-btn {
    position: relative;
    .page-btn-el {
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -475px;
      padding: 20px 0;
      background-color: #fff;
      width: 950px;
      box-shadow: #d4d4d4 0 0 2px 2px;
      margin-bottom: 40px;
    }
  }
  .reports {
    .reports-generate-form {
      .el-form-item__content {
        z-index: 9999;
      }
      .label-mark {
        display: none;
      }
    }
    .label-mark {
      z-index: 9999;
    }
  }
}
</style>

<style lang="less" scoped>
@import url("~@/assets/css/lesson/exp/marking/scoped.less");
.pdf-body {
  width: 950px;
}
.textLayer {
  padding: 40px;
  position: relative;
}
.textLayer > div {
  color: #000;
  position: static;
  line-height: normal;
}
.title {
  text-align: center;
  font-size: 25px;
  color: #1e1e1e;
}
.report-table {
  background-color: #3c3c3c;
  margin-top: 20px;
  tbody {
    tr {
      td {
        padding: 15px 5px;
        background-color: #fff;
        width: 120px;
      }
      .td-t {
        color: #000;
      }
      .td-c {
        font-size: 14px;
      }
      .content-td {
        text-align: left;
        max-width: 500px;
        .reports {
          min-height: 700px;
          padding: 30px 20px;
          .report {
            margin-bottom: 20px;
            .report-title {
              color: #006eff;
              background-color: #e6e6e6;
              font-size: 20px;
              line-height: 20px;
              padding: 5px 280px 5px 5px;
              position: relative;
              img {
                vertical-align: middle;
              }
              .report-answers {
                font-size: 0.7em;
                position: absolute;
                top: 50%;
                right: 200px;
                transform: translateY(-50%);
                z-index: 99999;
              }
              .report-score {
                font-size: 0.7em;
                position: absolute;
                top: 50%;
                right: 5px;
                transform: translateY(-50%);
                z-index: 99999;
                .el-input {
                  width: 72px;
                  display: inline-block;
                  vertical-align: middle;
                }
              }
            }
            .report-content-box {
              position: relative;
              min-height: 180px;
              .report-content {
                padding: 5px 20px;
                line-height: 24px;
                overflow: hidden;
              }
              .report-revise {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                background-color: white;
              }
            }
          }
        }
      }
    }
  }
}
</style>
